import React from 'react';
import styles from './enrichment-favicon.module.sass';
import { Typography, Button, Table, Tooltip } from 'antd';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import { Link } from 'react-router-dom';

function EnrichmentFavicon({ newData, statusNew, type, props }) {
  const { Title, Text } = Typography;
  let favicon = undefined;
  let ioc = undefined;

  if (type === 'domain') {
    favicon = newData?.response?.scan_data;
    ioc = newData?.response?.domaininfo?.domain;
  } else if (type === 'ipv4') {
    if (newData?.response?.ip2asn) {
      favicon = newData?.response?.ip2asn?.[0]?.scan_data;
      ioc = newData?.response?.ip2asn?.[0]?.ip;
    }
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Name" />,
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'value',
      key: 'value',
      className: 'ant-column-white',
    },
  ];

  function returnTableData({ loading, iocType }) {
    return [
      {
        key: 1,
        name: 'Favicon md5',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <div className={styles.value_with_button}>
            <Text strong>
              {favicon?.favicon?.[0]?.favicon_md5
                ? favicon?.favicon?.[0]?.favicon_md5
                : '-'}
            </Text>
            {props?.mySubscriptionPlan?.has_access_to_query_builder ? (
              <Link
                to={
                  `/explore-result?name=${
                    favicon?.favicon?.[0]?.favicon_md5 ?? ''
                  }&queryType=favicon&type=favicon&fromQueryBuilder=true&backLink=${encodeURIComponent(
                    window.location.pathname,
                  )}${encodeURIComponent(
                    window.location.search,
                  )}&originalQueryURL=scandata%2Fipv4%2Ffavicon%3Fnetmask%3D32%26net%3Din%26md5%3D${
                    favicon?.favicon?.[0]?.favicon_md5 ?? ''
                  }%26limit%3D100%26max_wait%3D25%26with_metadata%3D1&origin_uid=FAVICON_MD5`

                  // `/explore/query-builder?query=142ef207-aee7-493a-a1b5-a39c9e2c8953&md5=${
                  //   favicon?.favicon?.[0]?.favicon_md5 ?? ''
                  // }&backLink=` +
                  // encodeURIComponent(window.location.pathname) +
                  // encodeURIComponent(window.location.search)
                }
              >
                <Button
                  type="primary"
                  disabled={!favicon?.favicon?.[0]?.favicon_md5}
                >
                  Find More
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_query_builder ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button
                  disabled={
                    !props?.mySubscriptionPlan?.has_access_to_query_builder
                  }
                  type="primary"
                >
                  Find More
                </Button>
              </Tooltip>
            )}
          </div>
        ),
      },
      {
        key: 2,
        name: 'Favicon murmur3',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <div className={styles.value_with_button}>
            <Text strong>
              {favicon?.favicon?.[0]?.favicon_mmh3
                ? favicon?.favicon?.[0]?.favicon_mmh3
                : '-'}
            </Text>
            {props?.mySubscriptionPlan?.has_access_to_query_builder ? (
              <Link
                to={
                  `/explore-result?name=${
                    favicon?.favicon?.[0]?.favicon_mmh3 ?? ''
                  }&queryType=favicon&type=favicon&fromQueryBuilder=true&backLink=${encodeURIComponent(
                    window.location.pathname,
                  )}${encodeURIComponent(
                    window.location.search,
                  )}&originalQueryURL=scandata%2Fipv4%2Ffavicon%3Fnetmask%3D32%26net%3Din%26mmh3%3D${
                    favicon?.favicon?.[0]?.favicon_mmh3 ?? ''
                  }%26limit%3D100%26max_wait%3D25%26with_metadata%3D1&origin_uid=FAVICON_MURMUR3`

                  // `/explore/query-builder?query=142ef207-aee7-493a-a1b5-a39c9e2c8953&mmh3=${favicon?.favicon[0]?.favicon_mmh3}&backLink=` +
                  // encodeURIComponent(window.location.pathname) +
                  // encodeURIComponent(window.location.search)
                }
              >
                <Button
                  type="primary"
                  disabled={!favicon?.favicon?.[0]?.favicon_mmh3}
                >
                  Find More
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_query_builder ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button
                  disabled={
                    !props?.mySubscriptionPlan?.has_access_to_query_builder
                  }
                  type="primary"
                >
                  Find More
                </Button>
              </Tooltip>
            )}
          </div>
        ),
      },
      {
        key: 3,
        name: 'Favicon2 md5',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {favicon?.favicon?.[0]?.favicon2_md5
              ? favicon?.favicon?.[0]?.favicon2_md5
              : '-'}
          </Text>
        ),
      },
      {
        key: 4,
        name: 'Favicon2 murmur3',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {favicon?.favicon?.[0]?.favicon2_mmh3
              ? favicon?.favicon?.[0]?.favicon2_mmh3
              : '-'}
          </Text>
        ),
      },
      {
        key: 5,
        name: 'Favicon2 path',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {favicon?.favicon?.[0]?.favicon2_path
              ? favicon?.favicon?.[0]?.favicon2_path
              : '-'}
          </Text>
        ),
      },
      {
        key: 6,
        name: 'Scan Date',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {favicon?.favicon?.[0]?.scan_date
              ? favicon?.favicon?.[0]?.scan_date
              : '-'}
          </Text>
        ),
      },
    ];
  }

  return (
    <div className={styles.enrichment_favicon}>
      <Title level={4}>Favicon</Title>
      <Table
        columns={columns}
        dataSource={returnTableData({
          loading: statusNew === 'loading',
          iocType: type,
        })}
        pagination={false}
      />
    </div>
  );
}

export default EnrichmentFavicon;
